import { createAction, props } from '@ngrx/store';
import { DeclineReason } from '../../interfaces/decline-reason';

export const loadDeclineReasons = createAction('[DeclineReason/API] Load Decline Reasons');

export const loadDeclineReasonsSuccess = createAction(
  '[DeclineReason/API] Load Decline Reasons Success',
  props<{ declineReasons: DeclineReason[] }>()
);

export const loadDeclineReasonsFailure = createAction(
  '[DeclineReason/API] Load Decline Reasons Failure',
  props<{ error: any }>()
);
